<template>
  <div class="upload-multiple-image">
    <v-layout wrap fill-height>
      <v-flex
        class="pr-2 pb-3 pl-2"
        v-if="images.length < limit"
        style="cursor: pointer; height: 130px"
      >
        <div
          class="btn-upload"
          style="
            border-radius: 10px;
            border: 4px dashed #eee;
            display: inline-table;
            width: 100%;
            height: 100%;
            padding-top: 13px;
          "
          onclick="document.getElementById('photoUploadInputMultiple').click()"
          @dragover.prevent
          @drop.prevent="onFileChange($event)"
        >
          <v-responsive>
            <v-row column justify="center" fill-height align="center">
              <v-col v-if="!loading">
                <div class="text-center" style="color: #0c4d9d">
                  <v-icon color="#0c4d9d" large>camera_alt</v-icon>
                  <br />เลือกไฟล์เพื่ออัพโหลด
                </div>
              </v-col>
              <v-col v-else class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="30"
                ></v-progress-circular>
              </v-col>
            </v-row>
          </v-responsive>
        </div>
      </v-flex>
    </v-layout>

    <div class="form-control has-error" v-if="isAlert">
      <span class="text-error">{{ "Please try to upload file again" }}</span>
    </div>
    <input
      type="file"
      multiple
      class="form-control-file pt-2"
      name="photoUpload"
      id="photoUploadInputMultiple"
      data-vv-as="File"
      accept="image/*;capture=camera"
      @change="onFileChange($event)"
      style="
        overflow: hidden;
        position: fixed;
        width: 1px;
        height: 1px;
        z-index: -1;
        opacity: 0;
      "
    />
    <div>
      <v-row>
        <v-col
          @mouseover="hover = k"
          @mouseleave="hover = ''"
          v-for="(item, k) in value"
          :key="k"
          cols="3"
          class="pr-1"
        >
          <div style="position: relative">
            <v-img height="60px" :src="item" @error="() => (item = null)">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div
              v-if="hover === k"
              style="position: absolute; right: 0px; top: 0px; z-index: 1"
            >
              <v-btn @click="deleteImg(k)" small icon outlined color="primary"
                ><v-icon>close</v-icon></v-btn
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import UpdateMultipleFileMixin from "./UpdateMultipleFileMixin.js";
export default {
  mixins: [UpdateMultipleFileMixin],
};
</script>

<style scoped lang="scss">
.btn-upload {
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>